export default function (state, getters) {
    if(!state.form.AgreementCodes.length)return [];
    return getters['agreements/contragents'](state.form.AgreementCodes[0]);
}